module.exports = __webpack_public_path__ + "img/edu-institution-4.7fadf877.png";